import { ApiFunc, getInstance } from '@helpers/httpClient'
import { dissoc, prop } from 'ramda'

import * as API from '../constants/api'

const instance = getInstance()

export const contractAgreement: ApiFunc<`${typeof API.CONTRACT_AGREEMENT}{id}`, 'get'> = data =>
  instance.get(`${API.CONTRACT_AGREEMENT_ALL}${'id' in data ? prop('id', data) : data?.name ? data.name : ''}`, {
    params: 'id' in data ? dissoc('id', data) : dissoc('name', data),
  })

export const contractAgreementAll: ApiFunc<`${typeof API.CONTRACT_AGREEMENT_ALL}`, 'get'> = data =>
  instance.get(API.CONTRACT_AGREEMENT_ALL, {
    params: data,
  })

export const contractAgreementOpen: ApiFunc<`${typeof API.CONTRACT_AGREEMENT_OPEN}`, 'get'> = data =>
  instance.get(API.CONTRACT_AGREEMENT_OPEN, {
    params: data,
  })

export const contractAgreementCurrent: ApiFunc<`${typeof API.CONTRACT_AGREEMENT_CURRENT}`, 'get'> = data =>
  instance.get(API.CONTRACT_AGREEMENT_CURRENT, {
    params: data,
  })

export const contractAgreementAccept: ApiFunc<`${typeof API.CONTRACT_AGREEMENT_ACCEPT}`, 'post'> = data =>
  instance.post(API.CONTRACT_AGREEMENT_ACCEPT, data)

export const contractDownload: ApiFunc<`${typeof API.CONTRACT_DOWNLOAD}`, 'post'> = data =>
  instance.post(API.CONTRACT_DOWNLOAD, data)
